export * from './gs-icon.component';